import { PropsWithChildren } from 'react'

export enum CardMode {
    DEFAULT = 'default',
    SQUARE = 'square',
}

export enum CardBorderColor {
    LIGHTEST_BLUE = 'lightest-blue',
    LIGHT_GREEN = 'light-green',
    LIGHT_YELLOW = 'light-yellow',
}

export interface CardProps extends PropsWithChildren<unknown> {
    hideBorderOnMobile?: boolean
    mode?: CardMode
    borderLeftColor?: CardBorderColor
    class?: string
}
